import React, { useCallback, useEffect, useState } from 'react';
import useFetch from '../../hooks/useFetch';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter } from '@fortawesome/free-brands-svg-icons';
import logo from '../../assets/logo.png';
import "../../styles/MyProfile.css";
import QRCode from 'react-qr-code';


const MyDigitalCardFarmer = () => {
  const authState = useSelector(state => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState.user._id;
  const userCode = authState.user.think5whyscode;

  const [profileData, setProfileData] = useState({
    userId: authState.user._id,
    name: authState.user.name,
    gender: 0,
    dob: '',
    email: authState.user.email,
    mobile: '',
    city: '',
    personalPageLink: '',
    think5whysCode: authState.user.think5whyscode,
    image: '',
  });

  const [profileExists, setProfileExists] = useState(false);
  const [profileId, setProfileId] = useState('');
  const [loading, setLoading] = useState(true);
  const [createSuccessMsg, setCreateSuccessMsg] = useState('');
  const [urlToScan, setUrlToScan]=useState('');

  const buttonStyle = {
    marginLeft: '10px',
    padding: '5px 10px',
    fontSize: '11px',
    cursor: 'pointer',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#0000ab',
    color: '#fff'
  };

  const button1Style = {
    margin: '10px',
    padding: '10px',
    fontSize: '11px',
    backgroundColor: '#0000ee',
  };

  const button2Style = {
    margin: '10px',
    padding: '10px',
    fontSize: '14px',
    backgroundColor: '#0000ee',
  };

  useEffect(() => {
    fetchUserProfile(userId);
  }, [userId]);

  const fetchUserProfile = useCallback(() => {
    const config = {
      url: "/blueprofile/byid",
      method: 'post',
      data: { userId: userId },
      headers: { Authorization: authState.token },
    };
    fetchData(config)
      .then(response => {
        if (response && response.status) {
          setProfileExists(true);
          const { blueProfile } = response;
          setProfileId(blueProfile._id);
          setProfileData({
            userId: blueProfile.userId,
            name: blueProfile.name,
            gender: blueProfile.gender,
            dob: blueProfile.dob,
            email: blueProfile.email,
            mobile: blueProfile.mobile,
            city: blueProfile.city,
            personalPageLink: blueProfile.personalPageLink,
            think5whysCode: blueProfile.think5whysCode,
            bloodGroup: blueProfile.bloodGroup,
          });
        } else {
          setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
        }
      })
      .catch(error => {
        console.error("Error getting profile:", error);
        setCreateSuccessMsg("Sorry! Profile Not Found. Please retry.");
      });
  }, [userId, fetchData, authState.token]);

  const origin = window.location.origin;
  const qrValue = `${origin}/pub/blue/${profileData.think5whysCode}`;

  const handleCallClick = (contactNumber) => {
    window.location.href = `tel:${contactNumber}`;
  };

  const handleWhatsAppClick = (contactNumber) => {
    const whatsappUrl = `https://wa.me/${contactNumber}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleEmailClick = (contactEmail) => {
      window.location.href = `mailto:${contactEmail}`;
  };

   const handleEmergencyCallClick = (contactNumber) => {
    window.location.href = `tel:${contactNumber}`;
  };

  const handlePersonalDetailsClick = () => {
    
  };

  const handleKYCInfoClick = () => {
    
  };

  const handleSkillScoresClick = () => {
    
  };

  return (
    <div className="flex justify-center items-center p-4">
      <div className="bg-gradient-to-r from-green-500 to-green-800 border border-gray-600 rounded-2xl shadow-2xl w-full max-w-lg p-6">

        {/* Profile Image */}
        <div className="flex justify-center mb-4">
          <img 
            src={
              `/api/downloads/users/profilepic/${profileData.think5whysCode}.png` || 
              `/api/downloads/users/profilepic/noprofilepic.png`
            }
            alt="Profile Pic"
            className="w-36 h-36 rounded-full border-4 border-yellow-400 shadow-xl"
          />
        </div>

        {/* Name & Details */}
        <h2 className="text-white font-extrabold text-3xl mb-2 text-center tracking-wide">
          {profileData.name}
        </h2>

        <div className="text-center text-white text-sm space-y-1">
          <p>ID#: {profileData.think5whysCode}</p>
          <p>Blood Group: {profileData.bloodGroup}</p>
          <p>Email: {profileData.email}</p>
          <p>Mobile: {profileData.mobile}</p>
          <p>Place: {profileData.city}</p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-center mt-4">
          <button onClick={handleSkillScoresClick} style={buttonStyle}>
            🌱 Growing
          </button>
        </div>

        <div className="flex justify-center gap-4 mt-4">
          <button onClick={handlePersonalDetailsClick} style={button1Style}>
            🧍 Details
          </button>
          <button onClick={handleKYCInfoClick} style={button1Style}>
            🛂 KYC
          </button>
        </div>

        <div className="flex flex-row justify-center gap-4 mt-4">
          <button onClick={handleCallClick} style={button2Style}>📞</button>
          <button onClick={handleWhatsAppClick} style={button2Style}>💬</button>
          <button onClick={handleEmailClick} style={button2Style}>✉️</button>
          <button onClick={handleEmergencyCallClick} style={button2Style}>📞 Emergency</button>
        </div>

        {/* QR Code */}
        <div className="bg-black border-4 border-gray-600 rounded-xl mt-6 p-4 w-full flex flex-col items-center">
          <QRCode value={qrValue} size={128} className="bg-white p-2 rounded-md shadow-md" />
          <a
            href={qrValue}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-4 text-xs break-all text-blue-300 hover:text-blue-400"
          >
            {qrValue}
          </a>
        </div>

        {/* Footer Branding */}
        <div className="mt-4 p-3 w-full flex flex-col items-center">
          <p className="text-yellow-200 text-center text-sm py-2">
            Powered by 
            <img
              src={logo}
              alt="Think5Whys"
              className="inline-block w-6 h-6 mx-2 align-middle"
            /> 
            think5whys.com
          </p>
        </div>

      </div>
    </div>

   );
};

export default MyDigitalCardFarmer;
